import { ClassNameMap, Grid, Typography } from "@mui/material";
import React from "react";
import OutlinedButton from "../common/OutlinedButton";

interface OptionProps {
  name: string;
  defaultOption: string;
  icon?: JSX.Element;
  width?: string | number;
  fullWidth?: boolean;
  isSelected?: boolean;
  buttonStyles?: (props?: any) => ClassNameMap<"root">;
  onClick?: (e: any) => void;
}

const Option = (props: OptionProps) => {
  const { name, width, fullWidth, defaultOption, icon, isSelected, onClick, buttonStyles } = props;

  return (
    <Grid
      item
      container
      alignItems="center"
      sx={{
        width: width ?? "fit-content",
        paddingRight: "20px",
      }}
    >
      <Typography sx={{ paddingRight: "15px", color: "#3D4346" }}>{name}</Typography>
      <OutlinedButton
        endIcon={icon}
        onClick={(e) => {
          onClick && onClick(e);
        }}
        fullWidth={fullWidth}
        styles={buttonStyles}
        isSelected={isSelected}
      >
        {defaultOption}
      </OutlinedButton>
    </Grid>
  );
};

export default Option;
